import styled from '@emotion/styled';
import useIsActive from '@shared/hooks/useActiveNavLink';
import { IMenuItem } from '@shared/models/components/IMenuProps';
import { NavLink } from 'react-router';
import Icons from '../images/Icons';
import {
    MENU_ICON_SIZE,
    MenuActiveBar,
    MenuTruncate,
    MixinMenuBaseLink,
    MixinMenuFlexContainer,
    MixinMenuItemLabel,
} from './CommonMenuStyles';

interface IMenuItemProps {
    item: IMenuItem;
}

export default function MenuItem({ item }: IMenuItemProps) {
    const { exactMatch } = useIsActive(item.href);

    return (
        <>
            <MenuActiveBar isActive={exactMatch} isSubActive={!!item.activeSub} />

            {item.href ? (
                <MenuItemLink id={item.id} role="menuitem" to={item.href} target={item.target} viewTransition>
                    <MenuLabel>
                        <Icons name={item.icon} size={MENU_ICON_SIZE} />
                        <MenuTruncate $isActive={exactMatch ?? !!item.activeSub}>{item.label}</MenuTruncate>
                    </MenuLabel>
                </MenuItemLink>
            ) : (
                <MenuLabel id={item.id} role="menuitem">
                    <Icons name={item.icon} size={MENU_ICON_SIZE} />
                    <MenuTruncate $isActive={exactMatch ?? !!item.activeSub}>{item.label}</MenuTruncate>
                </MenuLabel>
            )}
        </>
    );
}

const MenuLabel = styled.span`
    ${MixinMenuFlexContainer}
    gap: 0.25rem;
    justify-items: center;
`;

const MenuItemLink = styled(NavLink)`
    ${MixinMenuBaseLink}
    padding: 0 0.25rem;
    flex: 1;
    justify-self: center;
    ${(props) => MixinMenuItemLabel(props.theme)}
`;
